import React from 'react'
import './Iconos.css'
import { MdInsertChart } from 'react-icons/md'

const IconoReporte = (props) => {
    return <span className={"icono-mp" + (props.background ? " background-reporte" : "")}><MdInsertChart /></span>
}

export default IconoReporte